/**
 * The platform's own brand colours, mirroring the backend registry fallbacks
 * and `--color-primary` / `--color-brand-accent` in styles/index.css.
 *
 * A tenant that has configured nothing resolves to exactly these, so anything
 * showing a "current" colour must use them rather than a placeholder.
 */
export const DEFAULT_PRIMARY = '#7C2A13';
export const DEFAULT_ACCENT = '#F24A02';
